import { render } from "./gzhNewsList.vue?vue&type=template&id=194d17a0"
import script from "./gzhNewsList.vue?vue&type=script&lang=js"
export * from "./gzhNewsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__